import React from 'react';
// components
import {
  StyledModal,
  FolderSelector,
  CustomNotification,
} from 'common/components';
import AddToFolderActions from 'common/components/grid-view/components/add-to-folder/AddToFolderActions';
// hooks
import {
  useHandleAddSearchProductToFolder,
  useAddSearchProductToFolder,
} from 'hooks/folders/useAddSearchProductToFolder';

import { useGlobalModal } from 'hooks';
import { handleCreateSearchContainer } from 'pages/reporting/utils';

import './ModalAddSearchProductToFolder.less';

const ModalAddSearchProductToFolder = (props) => {
  const { hasPermissionAddToFolder, dataQueryConditions } = props;

  const addSearchProductToFolder = useAddSearchProductToFolder();

  const { MODAL_NAMES, checkModalVisible, closeModalList } = useGlobalModal();
  const isShowAddToFolder = checkModalVisible(
    MODAL_NAMES.ADD_SEARCH_PRODUCT_TO_FOLDER
  );

  const {
    folderSelectorRef,
    onSelectFolder,
    onBreadcrumbChange,
    onExpandFolder,
    selectedFolder,
    currentFolderId,
  } = useHandleAddSearchProductToFolder();

  const handleCloseModal = () => {
    closeModalList([
      MODAL_NAMES.CREATE_FOLDER,
      MODAL_NAMES.ADD_SEARCH_PRODUCT_TO_FOLDER,
    ]);
    onSelectFolder(null);
  };

  const handleSuccessCallback = (folder) => {
    const advancedSearchContainer =
      handleCreateSearchContainer(dataQueryConditions);
    const params = {
      folderId: folder?.id,
      advancedSearchContainer,
    };
    addSearchProductToFolder.mutate(params, {
      onSuccess: (res) => {
        if (res?.isSuccess) {
          CustomNotification.success(
            res?.message ?? `Add to Folder successfully`
          );
          handleCloseModal();
        } else {
          CustomNotification.error(res?.message ?? 'Cannot add to folder');
        }
      },
      onError: () => {
        CustomNotification.error('Cannot add to folder');
      },
    });
  };

  const folderIdToAdd = selectedFolder?.id || currentFolderId;

  const selectedFolderId =
    selectedFolder?.id !== 'home' ? selectedFolder?.id : null;

  return (
    <StyledModal
      title={'Add results to Folder'}
      visible={isShowAddToFolder}
      bodyStyle={{ height: '70vh' }}
      maskClosable={false}
      destroyOnClose
      onCancel={handleCloseModal}
      footer={
        <AddToFolderActions
          loading={addSearchProductToFolder?.isLoading}
          parentId={selectedFolderId || currentFolderId}
          currentFolderId={currentFolderId}
          disableSubmitButton={!folderIdToAdd || !hasPermissionAddToFolder}
          onCancel={handleCloseModal}
          onSubmit={() => handleSuccessCallback(selectedFolder)}
          successCallback={handleSuccessCallback}
        />
      }
    >
      <FolderSelector
        ref={folderSelectorRef}
        loading={addSearchProductToFolder?.isLoading}
        onSelectFolder={onSelectFolder}
        onBreadcrumbChange={onBreadcrumbChange}
        onExpandFolder={onExpandFolder}
      />
    </StyledModal>
  );
};
export default ModalAddSearchProductToFolder;
